const callRequests = {
  getList: 'userCallRequest/getList',
  add: 'CallHistory/add',
  get: 'userCallRequest/get',
}
export default callRequests